export class BaseService {
 public static  BaseUrl:string="http://192.168.192.136:1367";
}
